import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="eci-footer">
      <div className="footer-container">
        {/* Quick Links */}
        <div className="footer-section">
          <h4>{t('footer.quickLinks') || 'Quick Links'}</h4>
          <div className="footer-links">
            <button onClick={() => navigate('/')}>{t('header.home') || 'Home'}</button>
            <button onClick={() => navigate('/vote-counting')}>{t('footer.voteCounting') || 'Vote Counting'}</button>
            <button onClick={() => navigate('/nominations')}>{t('footer.candidates') || 'Candidates'}</button>
          </div>
        </div>

        {/* Legal */}
        <div className="footer-section">
          <h4>{t('footer.legal') || 'Legal'}</h4>
          <div className="footer-links">
            <button onClick={() => navigate('/terms')}>{t('footer.terms') || 'Terms'}</button>
            <button onClick={() => navigate('/privacy')}>{t('footer.privacy') || 'Privacy'}</button>
            <button onClick={() => navigate('/disclaimer')}>{t('footer.disclaimer') || 'Disclaimer'}</button>
          </div>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h4>{t('footer.contact') || 'Contact'}</h4>
          <div className="footer-contact">
            <p><i className="fas fa-map-marker-alt"></i> Patna, Bihar 800001</p>
            <p><i className="fas fa-phone"></i> +91 7482909107</p>
            <p><i className="fas fa-envelope"></i> contact@bihar.com.co</p>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© {currentYear} {t('footer.copyright') || 'Bihar Election. All Rights Reserved.'}</p>
      </div>
    </footer>
  );
};

export default Footer;
